import { CurrencyPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-product-meta',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './product-meta.component.html',
  styleUrl: './product-meta.component.scss',
  providers: [CurrencyPipe],
})
export class ProductMetaComponent implements OnChanges {
  @Input() delivery: string = '';
  @Input() returnPolicy: string = '';
  @Input() shareLink: string = '';
  @Input() productDescription: string = '';

  /**
   * The price to show in share messages.
   * Pass the effective price (discounted if applicable, otherwise base price).
   */
  @Input() sharePrice: number = 0;

  shareDescription: string = '';

  constructor(private currencyPipe: CurrencyPipe) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['sharePrice'] || changes['shareLink']) {
      const formatted = this.currencyPipe.transform(this.sharePrice, 'NGN ') ?? '';
      this.shareDescription = `Check out this product in my store for just ${formatted}`;
    }
  }
}
